<template>
  <component
    :is="wrapperComponent"
    :to="link"
    :target="target"
    class="app-card"
  >
    <div class="app-card__header">
      <Icon
        v-if="iconName"
        class="app-card__icon"
        :name="iconName"
      />
      <AppPill
        v-if="label"
        highlight
        class="app-card__label"
      >
        {{ label }}
      </AppPill>
    </div>
    <div class="app-card__details">
      <span class="app-card__title h4">
        {{ title }}
      </span>
      <hr v-if="!!$slots.default" />
      <div
        v-if="!!$slots.default"
        class="app-card__content"
      >
        <slot />
      </div>
      <div
        v-if="!!$slots.button"
        class="app-card__button"
      >
        <slot name="button" />
      </div>
    </div>
  </component>
</template>

<script setup>
  import NuxtLink from '#app/components/nuxt-link'

  const props = defineProps({
    iconName: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
  })

  const wrapperComponent = props.link ? NuxtLink : 'div'
</script>

<style lang="scss">
  .app-card {
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 0 80px 0 var(--color-primary-15);
    background: white;
    border: 1px solid var(--color-primary-15);
    gap: 16px;
  }

  .app-card__header {
    position: relative;
    aspect-ratio: 4/2;
    background: var(--color-primary-15);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .app-card__label {
    position: absolute;
    top: 12px;
    right: 12px;
  }

  .app-card__icon {
    font-size: 64px;
    color: var(--color-primary);
  }

  .app-card__details {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex-grow: 1;
  }

  .app-card__content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .app-card__button {
    margin: auto 0 0;
  }

  .app-card__button > .app-button {
    width: 100%;
  }
</style>
